import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import {
	makeStyles,
	IconButton
} from '@material-ui/core';

const styles = makeStyles(theme => ({
	button: {
		color: theme.palette.common.white,
		"& a": {
			color: theme.palette.common.white,
		},

		[theme.breakpoints.up('lg')]: {
			color: theme.palette.primary.black,
			"& a": {
				color: theme.palette.primary.black,
			}
		}

	}
}));

function HeaderIconButton(props) {
	let classes = styles(),
		{children, handleClick, classOverrides} = props;

	return (
		<IconButton
			classes={classOverrides}
			className={classes.button}
			onClick={handleClick}>
			{children}
		</IconButton>
	);
}

HeaderIconButton.propTypes = {
	children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
	handleClick: PropTypes.func,
	classOverrides: PropTypes.object
};

export default withRouter(HeaderIconButton);